import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const TagsPage = () => (
  <Layout pagaTitle="All Topics">
    <SEO title="Tags" />

  </Layout>
)

export default TagsPage